import { Component, OnInit } from '@angular/core';
import { ReqResService } from '../../service/req-res.service';
import { PaginationInstance } from 'ngx-pagination';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { PluginService } from '../../service/plugin.service';
import { AuthService } from '../../service/auth/auth.service'
import { Title } from '@angular/platform-browser';

declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  loading = false;
  userData: any = [];
  sortReverse: boolean;
  sortType: string;
  searchU: string = '';
  userObj: any = {};
  userObjTemp: any;
  userLimit: number = 0;
  modalType: number = 0
  chkOpe: number = 0;
  disableButton: number = 0;
  changePasswordOpe: boolean = false;
  //del variables
  delId: number;
  delType: string;
  delCount: number;
  delBulkArray: any = [];
  delType2: string;
  modalTitle: string = '';
  userCount: number = 0;
  sortdirection: string = 'A';
  maxCount: number = 0;
  searchTimer: any = null;
  pendingRegistrations: any[] = [];
  pendingLoading: boolean = false;
  approvingRegistrationId: number = 0;
  public _pluginservice;
  constructor(private reqRes: ReqResService, private pluginservice: PluginService, private authService: AuthService, private titleService: Title) {
    this.titleService.setTitle('Users');
    this.searchU = '';
    this._pluginservice = this.pluginservice;
  }
  ngOnInit(): void {
    $('.modal-dialog').draggable({
      "handle": ".modal-header,.modal-footer"
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('.modal-dialog').attr('style', 'inset: unset')
    });
    this.sortReverse = true;
    this.sortType = 'createdate';

    let json = {
      "Search": '',
      "Count": this.userCount,
      "Direction": 'A',
      "SortType": this.sortType
    };

    this.getUserData(JSON.stringify(json), 0);
    this.loadPendingRegistrations();
    this._pluginservice.masterSelectedRefresh('userBulk', []);
    this._pluginservice.checkedList = [];
  }
  searchInputOperation() {
    $('.custom-search-input').focus();
    $("[data-toggle='tooltip']").tooltip('hide');
  }
  openFilter() {
    $("#divSearchFilterU").removeClass("d-none")
    $("#divSearchFilterU").addClass("d-inline-block")
    $("#divSearchFilterU").animate({ right: '0px' }, "slow");
    $("#btnSearchFilterU").hide();
    $("#inputSearchFilter").focus();
  }
  closeFilter() {
    $("#divSearchFilterU").removeClass("d-inline-block")
    $("#divSearchFilterU").addClass("d-none")
    $("#btnSearchFilter").show();
  }

  resetchkOpe() {
    this.chkOpe = 0;
  }
  checkUserEmail() {
    this.reqRes.getData('/User/GetUserStaticData/' + this.userObj.id + '/' + this.userObj.email).subscribe(data => {
      this.chkOpe = data[0].chkOpe;
      if (this.chkOpe == 0 || (data[0].chkOpe == 1 && this.userObj.id!=0)) {
        this.saveUser();
      }
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }
  modalUserClose() {
    let result = this.pluginservice.compareObjects(this.userObj, this.userObjTemp, ["id", "userRoles"])
    if (result) {
      if (confirm('Close without saving??')) {
        $('#userModal').modal('hide');
      }
    }
    else {
      $('#userModal').modal('hide');
    }
  }
  saveUser() {
    this._pluginservice.masterSelectedRefresh('userBulk');
    $("#userModal").modal('hide');
    this.disableButton = 1;
    this.userObj.imgPath = this.imageSrc
    this.reqRes.postData('/User/SaveUser', this.userObj).subscribe(data => {
      console.log(JSON.stringify(this.userObj));
      this.disableButton = 0;
      toastr.success('Done!', '', { timeOut: 1000 });
      if (data.length != 0) {
        let localStorage = data;
        this.authService.setUserData(localStorage);
       
      }

      let json = {
        "Search": '',
        "Count": '0',
        "Direction": 'A',
        "SortType": 'createdate'
      };
      this.userCount = 0;
      this.getUserData(JSON.stringify(json), 0);
      this.loadPendingRegistrations();
    }, error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
    })
  }

  loadPendingRegistrations(): void {
    this.pendingLoading = true;
    this.reqRes.getData('/User/GetPendingRegistrations').subscribe(
      (data: any) => {
        this.pendingRegistrations = Array.isArray(data) ? data : [];
        this.pendingLoading = false;
      },
      (error: any) => {
        this.pendingLoading = false;
        console.error('GetPendingRegistrations error:', error);
      }
    );
  }

  approvePendingRegistration(user: any): void {
    if (!user || !user.id || this.approvingRegistrationId !== 0) {
      return;
    }

    if (!confirm('Approve this registration and activate the user account?')) {
      return;
    }

    this.approvingRegistrationId = user.id;
    this.reqRes.postData('/User/ApprovePendingRegistration/' + user.id, {}).subscribe(
      (data: any) => {
        this.approvingRegistrationId = 0;
        this.pendingRegistrations = this.pendingRegistrations.filter(x => x.id !== user.id);

        if (data && data.emailSent === false) {
          toastr.warning(data.message || 'Account approved, but the email could not be sent.', '', { timeOut: 3000 });
        } else {
          toastr.success(data.message || 'Registration approved successfully.', '', { timeOut: 1800 });
        }

        this.userCount = 0;
        const json = {
          "Search": this.searchU,
          "Count": this.userCount,
          "Direction": this.sortdirection,
          "SortType": this.sortType
        };
        this.getUserData(JSON.stringify(json), 0);
      },
      (error: any) => {
        this.approvingRegistrationId = 0;
        const message = error && error.error && error.error.message
          ? error.error.message
          : 'Registration approval failed.';
        toastr.error(message, '', { timeOut: 2500 });
      }
    );
  }

  sortData(type) {
    this.sortType = type;
    this.userCount = 0;
    this.sortdirection = (this.sortReverse) ? 'D' : 'A';
    this.searchU = (this.searchU) ? this.searchU : '';
    let json = {
      "Search": this.searchU,
      "Count": this.userCount,
      "Direction": this.sortdirection,
      "SortType": this.sortType
    };
    this.getUserData(JSON.stringify(json), 0);
  }

  getUserData(json, ope) {
    this.loading = true;

    let GridParametrs: any = {};
    GridParametrs.type = 'users';
    GridParametrs.json = json;

    this.reqRes.postData('/Settings/GetSettingsViewData', GridParametrs).subscribe(data => {
      this.loading = false;
      this.userData = (ope == 0) ? this.userData = data.userData : this.userData.concat(data.userData);

      this.imageSrc = data.imgPath;

      this.maxCount = data.maxCount;
      //this._pluginservice.masterSelectedRefresh('roleBulk');
      if (this._pluginservice.checkedList.length == 1) {
        setTimeout(() => {
          $("#threeNo" + this.checkItemId + " button").prop('disabled', false);
          $("div[id^= 'threeNo'] button").prop('disabled', true);
        }, 500)
      } else if (this._pluginservice.checkedList.length > 1) {
        setTimeout(() => {
          $("div[id^= 'threeNo'] button").prop('disabled', true);
        }, 500)
      }
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error); this.loading = false;
      })
  }
  checkItemId: number = 0;
  getCheckedId(id) {
    this.checkItemId = id;
  }

  getSearchDataU(search) {
    this.searchU = (search) ? search : '';
    this.userCount = 0;

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    this.searchTimer = setTimeout(() => {
      let json = {
        "Search": this.searchU,
        "Count": this.userCount,
        "Direction":  'A',
        "SortType": this.sortType 
      };

      $("div[id^=threeNo] button").prop('disabled', false);
      this.getUserData(JSON.stringify(json), 0)
    }, 300);
  }

  onScrollData(event: any) {
    if (this.loading || this.userData.length >= this.maxCount) {
      return;
    }

    if (event.target.offsetHeight + event.target.scrollTop + 1 >= event.target.scrollHeight) {
      this.userCount = this.userCount + 50;
      let json = {
        "Search": this.searchU,
        "Count": this.userCount,
        "Direction": this.sortdirection,
        "SortType": this.sortType
      };
      this.getUserData(JSON.stringify(json), 1);
      //$("div[id^=threeNo] button").prop('disabled', false);
      //this._pluginservice.UnCheckAll(this.userData);
    }
  }

  chagenPasswordPermission() {
    this.userObj.password = ''
    this.userObj.confirmationPassword = ''
  }

  editUser(id) {
    this.chkOpe = 0;
    this.modalType = id;
    this.modalTitle = (id == 0) ? 'Add User' : 'Edit User';
    this.changePasswordOpe = (this.modalType == 0) ? true : false;
    this.reqRes.getData('/User/GetUserEditData/' + id + '/user').subscribe(data => {
      this.userObj = data;
      this.imageSrc = this.userObj.imgPath ? this.userObj.imgPath : '';
      //Clone User Modal Information to Temp Obj //
      const cloneOfObject = JSON.parse(JSON.stringify(this.userObj));
      this.userObjTemp = cloneOfObject;
      /////////////////////////////////////////////
      $("#userModal").modal('show');
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
  changeStatus(param, id, status, param2): void {
    if (param2 == 'changeStatus') {
      status = status ? 1 : 0;
    }
    let statusObj: any = {};
    statusObj.param = param;
    statusObj.id = id;
    statusObj.status = status;
    this.reqRes.postData('/User/ChangeUserStatus', statusObj).subscribe(data => {
      if (param == 'user' && status == -1) {
        let index = this.userData.findIndex(item => item.id == id);
        this.userData.splice(index, 1);
        toastr.success('Done!', '', { timeOut: 1000 });
      }
      else if (param == 'user') {
        toastr.success('Done!', '', { timeOut: 1000 });
      }
    }, error => {
        if (param == 'user' && param2 == 'changeStatus') {
          const user = this.userData.find(item => item.id == id);
          if (user) {
            user.status = status === 0;
          }
        }

        const message = error && error.error && error.error.message
          ? error.error.message
          : 'Oops! Something went wrong';
        toastr.error(message, '', { timeOut: 2500 });
        console.log(error)
    })
  }

  modalDelete(delId, delType, delType2, bulkArray) {
    this.delId = delId;
    this.delType = delType;
    this.delType2 = delType2;
    this.delBulkArray = bulkArray;
    if (bulkArray.length == 0) {
      this.delCount = 1;
    } else {
      this.delCount = this._pluginservice.checkedList.length;
    }
    $('#modalDelete').modal('show');
  }

  deleteItem(id, type, type2, array) {
    $("div[id^=threeNo] button").prop('disabled', false);
    $('#modalDelete').modal('hide');
    if (array.length == 0) {
      this.changeStatus(type, id, -1, type2);
    } else {
     let ids= this._pluginservice.bulkActions(array[0]);
      ids.forEach((id) => {
        let index = this.userData.findIndex(item => item.id == id);
        this.userData.splice(index, 1);
      });
    }
    this._pluginservice.masterSelectedRefresh('userBulk');
  }

  modalDeleteClose() {
    $('#modalDelete').modal('hide');
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedImageData: any = '';
  showcroppedope: any = 0;
  imageSrc: string = '';
  errorImage: string = '';
  spinner: boolean = false;
  //fileUpload start
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;

    if (event.target.files && event.target.files.length > 0) {
      if (event.target.files[0].type.includes("image/")) {
        $("#modal_file").modal('show');
        this.errorImage = '';
      } else {
        this.errorImage = 'Please input valid image format';
        event.target.value = '';
      }
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  SelectImage() {
    this.spinner = true;

    this.imageSrc = this.croppedImage;
    this.userObj.imgPath = this.imageSrc;

    $("#modal_file").modal('hide');
    this.spinner = false;
  }

  removeImage() {
    this.imageSrc = '';
    this.croppedImage = '';
    this.croppedImageData = '';
    this.imageChangedEvent = '';
    this.userObj.imgPath = '';

    const fileInput: any = document.getElementById('image');
    if (fileInput) {
      fileInput.value = '';
    }
  }

  segmentChange(segmentId) {
    this.reqRes.getData('/User/GetSubsegmentBySegmentId/' + segmentId).subscribe(data => {
      this.userObj.subSegmentObj = data;
      this.userObj.subSegmentId = 0;
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
  subSegmentChange(subsegmentId) {
    this.reqRes.getData('/User/GetSSubsegmentBySubsegmentId/' + subsegmentId).subscribe(data => {
      this.userObj.ssubSegmentObj = data;
      this.userObj.ssubSegmentId = 0;
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
}
